'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'diamond';
var width = 512;
var height = 512;
var aliases = [9830];
var unicode = 'f219';
var svgPathData = 'M0 256l11.3 11.3L244.7 500.7 256 512l11.3-11.3L500.7 267.3 512 256l-11.3-11.3L267.3 11.3 256 0 244.7 11.3 11.3 244.7 0 256zM256 489.4L22.6 256 256 22.6 489.4 256 256 489.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamond = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;